import { InjectionKey, reactive, computed, toRefs, nextTick } from 'vue';
import { createStore, Store, useStore as baseUseStore } from 'vuex';
import RootStateTypes, { AllStateTypes, PerspectiveEnum } from './types';
import wsModule from './modules/ws';
import { mock } from '@/store/mock';
import { freeze, getLocalStorge_varguardVisible, getLocalStorge_mapLabelVisible } from '@/utils/utils';

export const store = createStore<RootStateTypes>({
  state: {
    hideBottom: false,
    distanceMeasurement: {
      status: false,
      color: 'rgba(255,255,255,1)',
      clear: false,
    },
    perspective: {
      type: PerspectiveEnum.side,
      t: 0,
    },
    resources: [],
    modelMapTree: freeze([...mock]),
    modelMapTreeChecked: [],
    loadingText: '',
    mode: '',
    checkedEventTags: localStorage.getItem('checkedEventTags')
      ? JSON.parse(localStorage.getItem('checkedEventTags') as string)
      : [],
    alarmCodeList: [],
    varguardVisible: getLocalStorge_varguardVisible(),
    mapLabelVisible: getLocalStorge_mapLabelVisible(),
    allEventTags: [],
    checkedAlarmCodeList: [],
    mapVersionMeta: {}
  },
  getters: {
    localStorageModelMapTreeCheckedKey(state) {
      return `ModelMapTreeChecked-${state.mode}`;
    },
  },
  mutations: {
    changePerspective(state, data) {
      state.perspective = data;
    },
    changeDistanceMeasurement(state, data) {
      state.distanceMeasurement = freeze({
        ...state.distanceMeasurement,
        ...data,
      });
    },
    changeHideBottom(state, bool) {
      state.hideBottom = bool;
    },
    modelMapTreeChecked(state, modelMapTreeChecked) {
      state.modelMapTreeChecked = [];
      localStorage.setItem(
        store.getters.localStorageModelMapTreeCheckedKey,
        JSON.stringify(modelMapTreeChecked),
      );
      state.modelMapTreeChecked = freeze(modelMapTreeChecked);
    },
    setLoadingText(state, {text, is_hold = false}) {
      if (is_hold) {
        if (state.loadingText != text) {
          setTimeout(() => {
            state.loadingText = text;
          }, 0);
        }
      } else {
        state.loadingText = ""
        setTimeout(() => {
          state.loadingText = text;
        }, 0);
      }
    },
    setMode(state, type) {
      state.mode = type;
    },
    setResources(state, resources) {
      state.resources = resources;
    },
    setCheckedEventTags(state, checkedEventTags) {
      state.checkedEventTags = checkedEventTags;
      localStorage.setItem(
        'checkedEventTags',
        JSON.stringify(checkedEventTags),
      );
    },
    setAlarmCodeList(state, alarmCodeList) {
      state.alarmCodeList = alarmCodeList;
      localStorage.setItem(
        'checkedAlarmCodeList',
        JSON.stringify(alarmCodeList),
      );
    },
    setCheckedAlarmCode(state, checkedList) {
      state.checkedAlarmCodeList = checkedList;
    },
    setVarguardVisible(state, varguardVisible) {
      state.varguardVisible = varguardVisible;
      localStorage.setItem('varguardVisible_arr', JSON.stringify(varguardVisible));
    },
    setMapLabelVisible(state, mapLabelVisible) {
      state.mapLabelVisible = mapLabelVisible;
      localStorage.setItem('mapLabelVisible', mapLabelVisible);
    },
    setAllEventTags(state, allEventTags) {
      state.allEventTags = allEventTags;
    },
    setMapVersionMeta(state, data) {
      state.mapVersionMeta = data
    }
  },
  actions: {
    hasPermission({ state }, permission) {
      return state.resources.includes(permission);
    },
  },
  modules: {
    wsModule,
  },
});

export const key: InjectionKey<Store<RootStateTypes>> = Symbol('vue-store');

export function useStore<T = AllStateTypes>() {
  return baseUseStore<T>(key);
}

interface UseWsModuleArg<T> {
  (data: AllStateTypes['wsModule']): T;
}
export function useWsModule<T>(fn: UseWsModuleArg<T>) {
  const reactiveData = reactive({
    // @ts-ignore
    data: computed(() => fn(store.state.wsModule)),
  });
  return toRefs(reactiveData);
}
